import { render, staticRenderFns } from "./GSTConfigurationView.vue?vue&type=template&id=fa9e0e64"
import script from "./GSTConfigurationView.vue?vue&type=script&lang=js"
export * from "./GSTConfigurationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports